












import { Component, Vue, Prop } from "vue-property-decorator";
import ProgressBarCircle from "@/components/ProgressBar/ProgressBarCircle.vue";
import ProgressBarLinear from "@/components/ProgressBar/ProgressBarLinear.vue";

// this directive although dedicated for auth image, is reusable for this purpose
import AuthImage from "@/directives/AuthImage";

@Component({
  directives: {
    AuthImage: new AuthImage(),
  },
  components: { ProgressBarLinear, ProgressBarCircle },
})
export default class UnterrichtDashboardWidget extends Vue {
  public name = "UnterrichtDashboardWidget";

  @Prop({ default: () => "" })
  public widget!: any;

  public imageSrc = "";

  public get imgUrl(): string {
    const URL = "/unterricht-dashboard/img?widgetId=";
    const timestamp = new Date().getTime();
    return `${URL}${this.widget.id}&_=${timestamp}`;
  }

  public onImageError() {
    this.imageSrc = require("@/assets/unterricht/image_missing.jpeg");
  }

  // In Future, we can use maybe a more proper way, but this one for a temporary solution
  public handleClick(link: string): void {
    if (!link) {
      return;
    }

    if (link.startsWith("http")) {
      // Open the link in a new tab
      window.open(link, "_blank");
    } else {
      // Find the <a> element with the specified href
      const targetLink = document.querySelector(`a[href="${link}"]`);

      // Check if the element exists, then trigger a click
      if (targetLink instanceof HTMLAnchorElement) {
        targetLink.click();
      } else {
        console.log(`Link with href="${link}" not found.`);
      }
    }
  }

  public mounted() {
    this.imageSrc = this.imgUrl;
  }
}
